module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/ideal-baa43d1b30ffead81bd8e9c81cedfbd9.svg";